export default (location = {}) => {
  //@ts-ignore
  const { pathname } = location;
  if (!pathname) return '';

  const splitString = pathname.split('/');
  return splitString[1];
};
